import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export const REACTIONS = ["🍷", "❤️", "👏", "👍", "🔥"];

export default function ReactionBar({ tastingId, reactions, onUpdate, size = "md" }) {
  const [state, setState] = useState(reactions || { counts: {}, total: 0, my_reaction: null });
  const [busy, setBusy] = useState(false);

  const react = async (emoji, e) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/community/tastings/${tastingId}/react`, { emoji });
      setState(data);
      onUpdate?.(data);
    } catch {
      toast.error("No se pudo registrar la reacción");
    } finally {
      setBusy(false);
    }
  };

  const pad = size === "sm" ? "px-2 py-1 text-sm" : "px-2.5 py-1.5 text-base";

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`reaction-bar-${tastingId}`}>
      {REACTIONS.map((emoji) => {
        const count = state.counts?.[emoji] || 0;
        const active = state.my_reaction === emoji;
        return (
          <button
            key={emoji}
            data-testid={`react-${emoji}-${tastingId}`}
            onClick={(e) => react(emoji, e)}
            className={`inline-flex items-center gap-1 rounded-full border transition-all duration-200 ${pad} ${
              active ? "border-borgona-700 bg-borgona-50" : "border-grises-200 hover:border-borgona-300 hover:bg-blanco-off"
            }`}
          >
            <span>{emoji}</span>
            {count > 0 && <span className={`text-xs font-medium ${active ? "text-borgona-700" : "text-grises-500"}`}>{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
